export default __webpack_public_path__ + "static/media/gsb.ae249f10.svg";